module.exports = __webpack_public_path__ + "efc2cb6abd7c23c026c24f1fc2b44fd1.png";